document.addEventListener('DOMContentLoaded', function () {
	document.body.addEventListener('click', (event) => {
		if (!event.target.matches('.horizontal-nav__nav-link')) return;
		event.target.closest('.horizontal-nav').querySelectorAll('.horizontal-nav__nav-link').forEach(function (element) {
			element.classList.remove('active');
		});
		event.target.classList.add('active');
	});
});